export default [0, 2, 4, 8, 16, 24, 32, 48, 64, 96, 160];
